import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { SpinnerService } from '../../../app/service/spinner-service/spinner.service';
import { createWorker, PSM } from 'tesseract.js';
let cv = (window as any).cv;

@Component({
  selector: 'app-webcam',
  templateUrl: './webcam.component.html',
  styleUrls: ['./webcam.component.scss']
})
export class CapturaCamaraComponent implements OnInit, OnDestroy {
  
  @ViewChild('videoElement') videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvasElement') canvasElement!: ElementRef<HTMLCanvasElement>;
  @Input() opcion: number = 0;
  @Output() imageCaptured = new EventEmitter<{ image: string; opcion: number }>();
  @Output() capturaReiniciada = new EventEmitter<{ opcion: number }>();
  @Output() camaraReady = new EventEmitter<any>();
  
  public devices: MediaDeviceInfo[] = [];
  public selectedDeviceId: string | null = null;
  public stream: MediaStream | null = null;
  public capturedImage: string | null = null;
  showImage = false
  reloadDevices = true

  cvReady: boolean = false;

  constructor(private spinnerService: SpinnerService){

  }

  async ngOnInit(): Promise<void> {
    await this.loadDevices(1);
    this.waitForOpenCV();
    try {
      await this.startCameraWithFacingMode("environment");
    } catch (err) {
      console.warn("No se pudo abrir la cámara trasera, usando lista de dispositivos:", err);

      // Si falla, usar la lista de dispositivos y abrir el primero
      if (this.devices.length > 0) {
        this.selectedDeviceId = this.devices[0].deviceId;
        await this.startCamera(this.selectedDeviceId);
      } else {
        alert("No hay cámaras disponibles para seleccionar");
      }
    }
  }

  waitForOpenCV() {
    const check = () => {
      if (typeof cv !== 'undefined' && typeof cv.imread === 'function') {
        this.cvReady = true;
        // console.log('✅ OpenCV.js está listo');
      } else {
        setTimeout(check, 100);
      }
    };
    check();
  }

  async loadDevices(opc): Promise<void> {
    if(!this.reloadDevices){
      return
    }
    if(opc === 2 ){
      this.reloadDevices = false
    }
    const allDevices = await navigator.mediaDevices.enumerateDevices();
    this.devices = allDevices.filter(d => d.kind === 'videoinput');

    // Buscar cámara trasera
    const backCamera = this.devices.find(d =>
      d.label.toLowerCase().includes("back") ||
      d.label.toLowerCase().includes("rear") ||
      d.label.toLowerCase().includes("trasera") ||
      d.label.toLowerCase().includes("posterior") ||
      d.label.toLowerCase().includes("environment")
    );

    if (backCamera) {
      this.selectedDeviceId = backCamera.deviceId;
      this.startCamera(this.selectedDeviceId)
    }
  }

  async startCamera(deviceId: string): Promise<void> {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
    }

    try {
      const constraints = {
        video: deviceId ? { deviceId: { exact: deviceId } } : true,
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement.nativeElement.srcObject = this.stream;
      this.videoElement.nativeElement.onloadedmetadata = () => {
        this.videoElement.nativeElement.play();
        this.camaraReady.emit({ inicializada: true }); 
      };
      // this.videoElement.nativeElement.play();
      await this.loadDevices(2);
    } catch (err) {
      console.error('Error al iniciar la cámara:', err);
    }
  }

  async startCameraWithFacingMode(facingMode: "user" | "environment"): Promise<void> {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: { facingMode: { exact: facingMode } }
    });
    const videoElement = document.querySelector("video");
    if (videoElement) {
      videoElement.srcObject = stream;
    }
    this.loadDevices(2)
  }

  async onDeviceChange(event: Event): Promise<void> {
    const deviceId = (event.target as HTMLSelectElement).value;
    this.selectedDeviceId = deviceId;
    await this.startCamera(deviceId);
  }

  async captureImage() {
    // if (!this.cvReady) {
    //   console.error('❌ OpenCV.js aún no está listo');
    //   return;
    // }

    this.spinnerService.setMensaje('Procesando imagen')
    this.spinnerService.show()
    
    this.showImage = true
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    canvas.width = video.videoWidth * 2;
    canvas.height = video.videoHeight * 2;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Captura el frame del video
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    this.capturedImage =  canvas.toDataURL('image/png');

    // const src = cv.imread(canvas); // Captura desde canvas
    // const gray = new cv.Mat();
    // const contrast = new cv.Mat();
    // const hsv = new cv.Mat();
    // const mask = new cv.Mat();
    // const cleaned = new cv.Mat();
    // const result = new cv.Mat();

    // // 1. Convertir a escala de grises
    // cv.cvtColor(src, gray, cv.COLOR_RGBA2GRAY);

    // // 2. Aumentar contraste global
    // cv.equalizeHist(gray, contrast);

    // // 3. Convertir a HSV para filtrar negro
    // cv.cvtColor(contrast, hsv, cv.COLOR_GRAY2RGB);
    // cv.cvtColor(hsv, hsv, cv.COLOR_RGB2HSV);

    // // 4. Definir rango para "negro"
    // const low = new cv.Mat(hsv.rows, hsv.cols, hsv.type(), [0, 0, 0, 255]);
    // const high = new cv.Mat(hsv.rows, hsv.cols, hsv.type(), [180, 255, 40, 255]);

    // // 5. Crear máscara para el color negro
    // cv.inRange(hsv, low, high, mask);

    // // 6. Limpiar con operaciones morfológicas
    // const kernel = cv.Mat.ones(3, 3, cv.CV_8U);
    // cv.morphologyEx(mask, cleaned, cv.MORPH_CLOSE, kernel);
    // cv.morphologyEx(cleaned, cleaned, cv.MORPH_OPEN, kernel);
    // kernel.delete();

    // // 7. Aplicar la máscara al original
    // cv.bitwise_and(src, src, result, cleaned);

    // // 8. Convertir a blanco y negro para OCR
    // cv.cvtColor(result, result, cv.COLOR_RGBA2GRAY);
    // cv.threshold(result, result, 1, 255, cv.THRESH_BINARY);

    // // 9. Mostrar resultado en canvas
    // cv.imshow(canvas, result);


    // // Convierte el canvas procesado a imagen base64
    // this.capturedImage = canvas.toDataURL('image/png');
    // // 7. Limpieza
    // src.delete(); gray.delete(); contrast.delete(); hsv.delete();
    // mask.delete(); cleaned.delete(); result.delete(); low.delete
    
    // OCR con Tesseract
    // const worker = await createWorker('spa');
    // await worker.load();
    // await worker.setParameters({
    //   tessedit_char_whitelist: '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ-',
    //   tessedit_pageseg_mode: PSM.SINGLE_BLOCK
    // });

    // const { data } = await worker.recognize(this.capturedImage);
    this.capturedImage = this.capturedImage
    this.spinnerService.hide()
    // await worker.terminate();
    this.continuar()
  }

  async reintentar(){
    this.showImage = false
    this.capturedImage = null;
    this.camaraReady.emit({ inicializada: false }); 

    try {
      const constraints = {
        video: { deviceId: { exact: this.selectedDeviceId} }
      };
      this.stream = await navigator.mediaDevices.getUserMedia(constraints);
      this.videoElement.nativeElement.srcObject = this.stream;
      // this.videoElement.nativeElement.play();

      this.videoElement.nativeElement.onloadedmetadata = () => {
        this.videoElement.nativeElement.play();
        this.camaraReady.emit({ inicializada: true }); 
      };
      this.capturaReiniciada.emit({ opcion: this.opcion });
    } catch (err) {
      console.error('Error al iniciar la cámara:', err);
    }
  }

  continuar(): void {
    if (this.capturedImage) {
      this.imageCaptured.emit({
        image: this.capturedImage,
        opcion: this.opcion
      });
    }
  }

  ngOnDestroy(): void {
    this.stopCamera()
  }

  stopCamera(): void {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop());
      this.stream = null;
    }
  }
}
